var m = (M, x, y) => new Promise((A, C) => {
  var u = (c) => {
    try {
      h(y.next(c));
    } catch (p) {
      C(p);
    }
  }, n = (c) => {
    try {
      h(y.throw(c));
    } catch (p) {
      C(p);
    }
  }, h = (c) => c.done ? A(c.value) : Promise.resolve(c.value).then(u, n);
  h((y = y.apply(M, x)).next());
});
import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getUnifySelectInventoryDeliveryMethodsOptions as ce, getUnifySelectInventoryDeliveryMethodsRecords as de, getUnifySelectInventoryDeliveryMethodsBatchDeliveryMethods as ve } from "@oppein/op-utils";
import { postPageCommodityFromOriginalES as fe } from "../../../request/commoditycenter/commodity/pageCommodityFromOriginalES/post.js";
import { useLanguage as pe } from "../../../utils/useLanguage.js";
import { defineComponent as me, computed as v, watch as b, onMounted as be, openBlock as B, createElementBlock as ye, createVNode as he, withCtx as L, createBlock as z, createTextVNode as T, createCommentVNode as U } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as f, unref as k } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { toDisplayString as w } from "../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import H from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/checkbox/src/Checkbox.js";
import ge from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
const Ce = {
  key: 0,
  class: "delivery-method"
}, Ee = /* @__PURE__ */ me({
  __name: "deliveryMethodSelect.ce",
  props: {
    parameter: { type: Object }
  },
  emits: ["update:modelValue", "change", "returnOptions", "onChangeDeliveryMethod"],
  setup(M, { expose: x, emit: y }) {
    const { i18n: A } = pe(), { t: C } = A.global, u = M, n = f(), h = f([]), c = y, p = f([]), j = f(!1), I = f(!1), N = f(!1), _ = f(null), D = f(!1), g = v(() => {
      if (!n.value)
        return null;
      const { editableAttributeValue: e = [] } = n.value;
      return e.find(({ attributeCode: t }) => t === "deliveryMethod");
    }), F = v(() => {
      if (!n.value)
        return null;
      const { editableAttributeColumn: e = [] } = n.value, t = e.find(
        ({ attributeCode: a }) => a === "deliveryMethod"
      );
      return t == null ? void 0 : t.customOptions;
    }), E = v(() => {
      var e;
      return n.value ? n.value.productId || ((e = n.value.baseInfo) == null ? void 0 : e.productId) : null;
    }), P = v(() => {
      var t;
      if (!n.value)
        return null;
      const e = _.value.find(({ attributeCode: a }) => a === "classify1");
      return (t = e == null ? void 0 : e.attributeValues) == null ? void 0 : t.join(",");
    }), O = v(() => u.parameter.orderType === "LSD" && ["家配成品类", "家配售后类"].includes(P.value || "")), q = v(() => O.value ? !p.value || p.value.length < 1 : u.parameter.disabled), i = f("");
    b(
      () => u.parameter.deliveryModel,
      (e) => {
        e !== i.value && (i.value = e || "");
      },
      { immediate: !0 }
    ), b(i, (e) => {
      c("update:modelValue", e), O.value && g.value && (g.value.attributeValues = [e]);
    }), b(
      [g, () => u.parameter.deliveryModel],
      ([e, t]) => {
        t != null && t !== "" ? i.value = t : e != null && e.attributeValues ? i.value = e.attributeValues.join(",") : i.value = "";
      },
      { immediate: !0 }
    );
    const Q = v(() => {
      var t, a;
      const e = ce({
        list: ((t = u.parameter) == null ? void 0 : t.list) || [],
        records: u.parameter.isShowTitle ? ((a = u.parameter) == null ? void 0 : a.list) || [] : p.value || [],
        // 批量配送方式
        batchDeliveryMethods: h.value || []
      });
      if (Array.isArray(e)) {
        const s = /* @__PURE__ */ new Set();
        return e.filter((d) => {
          const o = typeof d == "string" ? d : d == null ? void 0 : d.value;
          return s.has(o) ? !1 : (s.add(o), !0);
        });
      }
      return j.value ? e : [];
    }), J = (e) => {
      i.value = e, c("update:modelValue", e);
    }, S = v(() => {
      var t, a;
      let e = [];
      return O.value ? e = G.value : e = ((t = F.value) == null ? void 0 : t.map((s) => ({
        label: s,
        value: s
      }))) || ((a = u.parameter.list) == null ? void 0 : a.map((s) => ({
        label: s.displayName,
        value: s.value
      }))) || [], e.length > 0 && (D.value = !0), c("returnOptions", e), e;
    }), G = v(() => Q.value ? Q.value.map((e) => typeof e == "string" ? { label: e, value: e } : { label: e.value, value: e.value }) : []), K = (e) => {
      c("onChangeDeliveryMethod", I.value, N.value, e), I.value && (I.value = !1), N.value && (N.value = !1);
    }, R = () => m(this, null, function* () {
      var e;
      if (!(!E.value || !((e = g.value) != null && e.attributeId)))
        try {
          const t = yield de({
            productId: E.value,
            attributeId: g.value.attributeId,
            customOptions: F.value
          });
          p.value = t || [], j.value = !0;
        } catch (t) {
          console.error("Failed to load delivery method options:", t);
        }
    }), W = () => m(this, null, function* () {
      if (u.parameter.destinationRegion)
        try {
          const e = yield ve({
            destinationRegion: u.parameter.destinationRegion || ""
          });
          h.value = e || [];
        } catch (e) {
          console.error("Error fetching delivery methods:", e);
        }
    });
    b(Q, (e) => {
      if (!Array.isArray(e))
        return;
      const t = e.map((a) => typeof a == "string" ? a : a.value);
      u.parameter.deliveryModel || e.length <= 0 && i.value || i.value && !t.includes(i.value) && (i.value = "");
    }), b(
      () => n.value,
      () => m(this, null, function* () {
        var e;
        O.value || u.parameter.list && u.parameter.list.length || !E.value || !((e = g.value) != null && e.attributeId) || (yield R());
      }),
      { immediate: !0 }
    ), b(
      [S, D],
      ([e, t]) => {
        if (!t || !i.value)
          return;
        e.map((s) => s.value).includes(i.value) || (i.value = "");
      },
      { immediate: !0 }
    ), b(D, (e) => {
      e && S.value.length === 0 && (i.value = "");
    });
    const X = () => m(this, null, function* () {
      var e, t;
      try {
        const a = yield fe({
          pageNo: 1,
          pageSize: 10,
          id: u.parameter.id || ""
        });
        a.status && ((t = (e = a.data) == null ? void 0 : e.records) != null && t.length) && Z(a.data.records[0]);
      } catch (a) {
        console.error("Error fetching commodity information:", a);
      }
    });
    function Y(e, t = []) {
      let a = [], s = [], d = [];
      return e = e || [], e.forEach((o) => {
        if (o.allowEdit || o.attributeCode === "isSelectFaucet" || o.attributeCode === "isNonStand") {
          if (o.allowEdit) {
            const r = {
              attributeCode: o.attributeCode,
              attributeName: o.attributeName
            };
            try {
              if (o.ruleExpression) {
                const { customOptions: V } = JSON.parse(o.ruleExpression);
                Object.assign(r, { customOptions: V });
              }
            } catch (V) {
              console.log(V);
            }
            a.push(r);
          }
          s.push({
            attributeCode: o.attributeCode,
            attributeValues: o.attributeValues,
            attributeId: o.attributeId,
            mustEdit: o.mustEdit
          });
        }
        t.some((r) => r === o.attributeCode) && d.push({
          attributeCode: o.attributeCode,
          attributeValues: o.attributeValues
        });
      }), { editableAttributeColumn: a, editableAttributeValue: s, attributes: d };
    }
    const Z = (e) => m(this, null, function* () {
      _.value = e.attributes;
      const {
        id: t,
        name: a,
        no: s,
        classificationId: d,
        classificationName: o,
        attributes: r,
        productionMode: V
      } = e, { editableAttributeColumn: ee, editableAttributeValue: te, attributes: ae } = Y(
        r,
        u.parameter.returnAttributes
      ), re = l(r, "leastOrder") ? Number(l(r, "leastOrder")) : l(r, "packageQuantity") ? Number(l(r, "packageQuantity")) : 1, le = l(r, "leastOrder") ? Number(l(r, "leastOrder")) : l(r, "packageQuantity") ? Number(l(r, "packageQuantity")) : void 0, ue = l(r, "maxLegacyNum") ? Number(l(r, "maxLegacyNum")) : l(r, "mostOrder") ? Number(l(r, "mostOrder")) : void 0, oe = l(r, "baseCount") ? Number(l(r, "baseCount")) : l(r, "packageQuantity") ? Number(l(r, "packageQuantity")) : 1, se = l(r, "orderIsMerge") ? Number(l(r, "orderIsMerge")) : 1, ie = l(r, "tips"), ne = {
        unit: l(r, "unit")
        // activityType: null
      };
      n.value = {
        commodityId: t,
        commodityName: a,
        pictureList: Array(e.mainPicture || 0),
        classificationId: d,
        classificationName: o,
        no: s,
        tagList: [],
        orderFlag: !0,
        quantity: re,
        minQuantity: le,
        maxQuantity: ue,
        baseCountStep: oe,
        orderIsMerge: se,
        tips: ie,
        attributes: ae,
        editableAttributeColumn: ee,
        editableAttributeValue: te,
        baseInfo: $(e),
        editQuantity: l(r, "editQuantity") !== "0",
        showConfigButton: !0,
        allowDelete: !0,
        paramConfig: ne
      };
    });
    function $(e) {
      let t = {};
      return Object.keys(e).forEach((a) => {
        a !== "attributes" && (t[a] = e[a]);
      }), t;
    }
    function l(e, t) {
      let a = "";
      return Array.isArray(e) && e.forEach((s) => {
        s.attributeCode === t && s.attributeValues && (a = s.attributeValues[0]);
      }), a;
    }
    return be(() => m(this, null, function* () {
      yield X(), O.value && (R(), W());
    })), x({
      selectOptions: S,
      selected: i,
      setSelected: J
    }), (e, t) => !u.parameter.optionEmptyHidden || S.value.length ? (B(), ye("div", Ce, [
      he(k(ge), {
        value: i.value,
        "onUpdate:value": [
          t[2] || (t[2] = (a) => i.value = a),
          K
        ],
        disabled: q.value,
        options: S.value,
        "label-field": "label",
        "value-field": "value",
        "key-field": "value",
        class: "tw:!w-[230px] tw:!text-left",
        size: "small",
        to: !1
      }, {
        action: L(() => [
          u.parameter.isClassify ? (B(), z(k(H), {
            key: 0,
            checked: N.value,
            "onUpdate:checked": t[0] || (t[0] = (a) => N.value = a),
            class: "tw:!text-left"
          }, {
            default: L(() => [
              T(w(k(C)("批量配置到同类产品")), 1)
            ]),
            _: 1
          }, 8, ["checked"])) : U("", !0),
          u.parameter.isAll ? (B(), z(k(H), {
            key: 1,
            checked: I.value,
            "onUpdate:checked": t[1] || (t[1] = (a) => I.value = a),
            class: "tw:!text-left"
          }, {
            default: L(() => [
              T(w(k(C)("批量配置到全部产品")), 1)
            ]),
            _: 1
          }, 8, ["checked"])) : U("", !0)
        ]),
        _: 1
      }, 8, ["value", "disabled", "options"])
    ])) : U("", !0);
  }
});
export {
  Ee as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/components/deliveryMethodSelect.ce.vue2.js
// module id = 1232
// module chunks = 41